<template>
  <v-container
    id="event"
  >
    <v-row>
      <v-col>
        <h2>Calendário de eventos geral</h2>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-sheet height="64">
          <v-toolbar flat color="white">
            <v-btn fab text small color="grey darken-2" @click="prev">
              <v-icon small>mdi-chevron-left</v-icon>
            </v-btn>
            <v-btn fab text small color="grey darken-2" @click="next">
              <v-icon small>mdi-chevron-right</v-icon>
            </v-btn>
            <v-toolbar-title>{{ title }}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-menu bottom right>
              <template v-slot:activator="{ on }">
                <v-btn
                  outlined
                  color="grey darken-2"
                  v-on="on"
                  
                >
                  <span>{{ typeToLabel[type] }}</span>
                  <v-icon right>mdi-menu-down</v-icon>
                </v-btn>
                <app-modal-insert-event
                  :dialog="dialog"
                  @onSave="getEvents"
                 
                ></app-modal-insert-event>
              </template>
              <v-list>
                <v-list-item @click="type = 'day'">
                  <v-list-item-title>Diária</v-list-item-title>
                </v-list-item>
                <v-list-item @click="type = 'week'">
                  <v-list-item-title>Semanal</v-list-item-title>
                </v-list-item>
                <v-list-item @click="type = 'month'">
                  <v-list-item-title>Mensal</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-toolbar>
        </v-sheet>

        <v-sheet height="600">
          <v-calendar
            locale="pt-BR"
            ref="calendar"
            v-model="focus"
            color="primary"
            :events="events"
            :event-color="'blue'"
            :event-more-text="'Ver mais eventos'"
            :event-end="'fim'"
            :event-name="'nome'"
            :event-start="'inicio'"
            :now="today"
            :type="type"
            @click:event="showEvent"
            @click:more="viewDay"
            @click:date="viewDay"
            @change="updateRange"
          >
          </v-calendar>
          
          <app-modal-edit-event
            :dialogEdicao="dialogEdicao"
            :payload="selectedEvent"
            @onSave="getEvents"
            @closeDialog="closeEdicaoDialog"
            
          >
          </app-modal-edit-event>
        </v-sheet>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex'
import { eventAPI } from '@/modules/event'
import AppModalInsertEvent from './ModalInsertEvent'
import AppModalEditEvent from './ModalEditEvent'

export default {
  components: {
    AppModalInsertEvent,
    AppModalEditEvent
  },
  data () {
    return {
      focus: '',
      type: 'month',
      typeToLabel: {
        month: 'Mensal',
        week: 'Semanal',
        day: 'Diária'
      },
      start: null,
      end: null,
      selectedEvent: {
        nome: null,
        municipiosEvento: [],
        municipios: []
      },
      selectedElement: null,
      selectedOpen: false,
      events: [],
      today: null,
      date: null,
      time: null,
      dialog: false,
      dialogEdicao: false,
      config: JSON.parse(localStorage.getItem("config"))
    }
  },
  computed: {
    title () {
      const { start, end } = this
      if (!start || !end) {
        return ''
      }

      const startMonth = this.monthFormatter(start)
      const startYear = start.year
      const startDay = start.day + this.nth(start.day)

      switch (this.type) {
        case 'month':
          return `${startMonth} ${startYear}`
        case 'week':
        case 'day':
          return `${startMonth} ${startDay} ${startYear}`
      }
      return ''
    },
    monthFormatter () {
      return this.$refs.calendar.getFormatter({
        timeZone: 'UTC', month: 'long'
      })
    }
  },
  mounted () {
    this.$refs.calendar.checkChange()
    this.getEvents()
  },
  methods: {
    ...mapActions([
      'setLoading'
    ]),
    viewDay ({ date }) {
      this.focus = date
      this.type = 'day'
    },
    setToday () {
      this.focus = this.today
    },
    prev () {
      this.$refs.calendar.prev()
    },
    next () {
      this.$refs.calendar.next()
    },
    showEvent ({ nativeEvent, event }) {
      this.dialogEdicao = true
      this.selectedEvent = event
    },
    updateRange ({ start, end }) {
      this.start = start
      this.end = end
    },
    nth (d) {
      return d > 3 && d < 21
        ? 'th'
        : ['th', 'st', 'nd', 'rd', 'th', 'th', 'th', 'th', 'th', 'th'][d % 10]
    },
    closeEdicaoDialog () {
      this.dialogEdicao = false
    },
    getEvents () {
      this.setLoading(true)
      this.dialogEdicao = false
      eventAPI.list()
        .then(resp => {
          this.events = resp.data
          this.setLoading(false)
        })
        .catch(resp => {
          this.setLoading(false)
          this.$notification.error('Erro ao buscar eventos')
        })
    }
  }
}
</script>
